import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { languageswitchConstants } from '../constants';
import { SocialMediaListRender } from './SocialMediaListRender';


export const SocialMediaListJP = () => {
    const dispatch = useDispatch();
    const s = useSelector(state => state.socialmediaJP.socialmediaListJP);
    const [socialmediaListJP, setSocialmedialListJP] = useState(s);
    const loading = useSelector(state => state.socialmediaJP.loading);
    const e = useSelector(state => state.socialmediaJP.error);
    const [error, setError] = useState(e);
    const d = useSelector(state => state.socialmediaJP.done);
    const [done, setDone] = useState(d);
    var dataLimitPerPage = 15;

    const lang = useSelector(state => state.languageswitch);
    if (lang === languageswitchConstants.JAPANESE_NR) {
        return <SocialMediaListRender
            stateList={s}
            socialmediaList={socialmediaListJP}
            setSocialmedialList={setSocialmedialListJP}
            loading={loading}
            errorState={e}
            error={error}
            setError={setError}
            doneState={d}
            done={done}
            setDone={setDone}
            dataLimitPerPage={dataLimitPerPage}
        />
    }
}